<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <tt-select ttLabel="resource_name" [(ttModel)]="page.resource_id" [ttData]="resources" ttDataId="resource_id" ttDataName="resource_name" ttRequired></tt-select>
        <tt-select ttLabel="report_checklist_name" [(ttModel)]="page.checklist_keyno" [ttData]="checklists" ttDataId="item_id" ttDataName="item_name" ttRequired></tt-select>
        <tt-textarea ttLabel="note" [(ttModel)]="page.note" ttRequired></tt-textarea>
        <tt-button ttText="erase" ttType="danger" ttIcon="fas fa-eraser" (ttClick)="page.note = ''"></tt-button>
        <tt-button-save ttText="sroperationaddr_save" [ttLoading]="saving" (ttClick)="saveChanges()"></tt-button-save>
    </tt-card>
</tt-page>
